
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.522 7.122c0 2.087-1.129 4.145-3.353 6.117a.516.516 0 01-.685-.773c1.994-1.767 3.005-3.565 3.005-5.344v-.025c0-1.444-.906-3.145-2.062-3.87a.516.516 0 11.549-.875c1.45.911 2.546 2.951 2.546 4.745v.025zm-6.7 4.356a.516.516 0 01-.504-.9c1.194-.67 1.998-1.971 2.001-3.24a3.134 3.134 0 00-1.68-2.773.516.516 0 11.48-.914 4.164 4.164 0 012.233 3.679v.016c-.007 1.628-1.022 3.287-2.53 4.132zM13.677 9.96a2.24 2.24 0 11.002-4.481 2.24 2.24 0 01-.002 4.48zm-3.442 1.318a.516.516 0 01-.703.199c-1.508-.845-2.524-2.504-2.53-4.132V7.33a4.164 4.164 0 012.232-3.679.517.517 0 01.48.914 3.134 3.134 0 00-1.68 2.772c.003 1.27.807 2.57 2.002 3.24.25.139.338.454.199.702zm-3.322 1.916a.515.515 0 01-.728.044c-2.225-1.972-3.353-4.03-3.353-6.117v-.025c0-1.794 1.095-3.834 2.546-4.745a.517.517 0 01.549.875c-1.157.725-2.063 2.426-2.063 3.87v.025c0 1.779 1.011 3.577 3.005 5.344.214.19.233.516.044.729zM19.903 0c-2.582 0-4.89 1.368-6.226 3.367C12.34 1.368 10.033 0 7.45 0A7.449 7.449 0 000 7.45c0 2.611 1.654 4.493 3.381 6.235l6.755 6.386a.555.555 0 00.936-.403v-4.976a2.61 2.61 0 012.605-2.609 2.61 2.61 0 012.605 2.61v4.975c0 .487.582.738.936.403l6.754-6.386c1.728-1.742 3.381-3.624 3.381-6.235A7.449 7.449 0 0019.903 0z","fill":"#C6002B","fill-rule":"evenodd"}})])
          )
        }
      }
    